// Existing diagnostic views share the same connection as the main application.
import magic from '../magic';
const can={
  eventEmitter:magic.bleEventDispatcher,
  connectBLE:()=>magic.connectBLE(),
  disconnectBLE:()=>magic.disconnectBLE(),
  cleanup:()=>magic.disconnectBLE(),
  sendCanFrame:()=>Promise.reject(new Error('Raw CAN injection is unavailable in gateway v1')),
};
export default can;
